/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 6a9f8221ded1412e0c73c8042598a49b6b82d13d493d76dc016d809401594a6e
 */
import {
  base_colorContentBorder,
  base_contentBackground,
} from 'ext-ui/style/colors'
import {
  cornerRadius,
  spacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  align-items: flex-start;
  background: ${base_contentBackground};
  border-color: ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  border-style: solid;
  border-width: 1px;
  box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  overflow: clip;
  position: relative;

  &.padding-large {
    padding-block: ${spacing(5)};
  }

  &.padding-none {
    padding-block: 0;
  }

  &.padding-small {
    padding-block: ${spacing(2)};
  }
`
